import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { i18n } from "../services/translation"; // Adjust the import path as necessary

const Navigation = ({ isAdmin, setIsAdmin }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  document.body.dir = i18n.dir();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang).then(() => {
      // do something after changing the language
      document.body.dir = i18n.dir();
      localStorage.setItem("language", newLang);
    });
  };

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      setIsAdmin(false);
      navigate("/admin-login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" className="mb-3">
      <Container>
        <nav className="navbar">
          <div className="navbar-container">
            {/* <Link to="/" className="navbar-logo">
              <img
                src={process.env.PUBLIC_URL + "/logo192.png"}
                alt="Manzely Logo"
                className="navbar-logo-image"
              />
            </Link> */}

            <a href={`${process.env.PUBLIC_URL}/landing.html`}>
              <img
                src={process.env.PUBLIC_URL + "/logo192.png"}
                alt="Manzely Logo"
                className="navbar-logo-image"
                as="a"
                href={`${process.env.PUBLIC_URL}/landing.html`}
              />
            </a>

            {/* Rest of your navigation content */}
          </div>
        </nav>
        {/* <Navbar.Brand as={Link} to="/">
          {t("DoctorHomeVisit")}
        </Navbar.Brand> */}
        <Navbar.Brand as="a" href={`${process.env.PUBLIC_URL}/landing.html`}>
          {t("Manzely")}
        </Navbar.Brand>
        <div variant="outline-primary" onClick={toggleLanguage}>
          <span
            style={{
              paddingRight: "5px",
              paddingLeft: "5px",
              marginLeft: "10px",
              marginRight: "10px",
              color: "white",
              fontWeight: "bold",
              backgroundColor: "red",
              cursor: "pointer",
            }}
          >
            {i18n.language === "en" ? "العربية" : "English"}
          </span>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">
              {t("Home")}
            </Nav.Link>
            <Nav.Link as={Link} to="/my-appointments">
              {t("MyAppointments")}
            </Nav.Link>
            {isAdmin && (
              <Nav.Link as={Link} to="/admin">
                {t("AdminDashboard")}
              </Nav.Link>
            )}
          </Nav>
          <Nav>
            {isAdmin ? (
              <Button variant="outline-light" onClick={handleLogout}>
                {t("Logout")}
              </Button>
            ) : (
              <Nav.Link as={Link} to="/admin-login">
                {t("AdminLogin")}
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
